import React, { useEffect, useMemo } from 'react'
import { useDispatch } from 'react-redux'
import { useSettings, setSettings } from '../slices/settings'
import { useGeolocationError } from '../slices/geolocation'
import { travelLength } from '../utils'
import {
  UNITS_OF_MESURE,
  METRIC,
  IMPERIAL,
  WALKING_PACE,
  RELAXED_WALKING_PACE,
  NORMAL_WALKING_PACE,
  FAST_WALKING_PACE,
  FONT_SIZE,
  SMALL,
  MEDIUM,
  BIG,
  GEOLOCATION,
  KEEP_SCREEN_ACTIVE
} from '../trans'


const SettingsControl = () => {

  const settings = useSettings()
  const dispatch = useDispatch() 
  const geolocationError = useGeolocationError()

  const onChangeHandler = (e) =>  {
    const value = {}
    value[e.target.name] = e.target.type === 'checkbox' ? e.target.checked : e.target.value
    dispatch(setSettings(value))
  }

  return (
    <form>

      <fieldset className="sidebar__fieldset">
        <legend>
          { UNITS_OF_MESURE }
        </legend>

        <label className="sidebar__radio">
          { METRIC } 
          <input
            type="radio"
            name="unit"
            value="m"
            checked={settings.unit == 'm'}
            onChange={onChangeHandler}
          />
        </label>
        <label className="sidebar__radio">
          { IMPERIAL }
          <input
            type="radio"
            name="unit"
            value="f"
            checked={settings.unit == 'f'}
            onChange={onChangeHandler}
          />
        </label>
      </fieldset>

      <fieldset className="sidebar__fieldset">

        <legend>{ WALKING_PACE }</legend>

        <label className="sidebar__radio">
          { RELAXED_WALKING_PACE + "  " +travelLength(3000, settings.unit) + "/h" } 
          <input
            type="radio"
            name="speed"
            value="1"
            checked={settings.speed == 1}
            onChange={onChangeHandler}
          />
        </label>
        <label className="sidebar__radio">
          { NORMAL_WALKING_PACE + " " + travelLength(4000, settings.unit)  + "/h" }
          <input
            type="radio"
            name="speed"
            value="2"
            checked={settings.speed == 2}
            onChange={onChangeHandler}
          />
        </label>
        <label className="sidebar__radio">
          { FAST_WALKING_PACE + " " + travelLength(5000, settings.unit) + "/h" }
          <input
            type="radio"
            name="speed"
            value="3"
            checked={settings.speed == 3}
            onChange={onChangeHandler}
          />
        </label>
      </fieldset>

      <fieldset className="sidebar__fieldset">

        <legend>{ FONT_SIZE }</legend>

        <label className="sidebar__radio">
          { SMALL } 
          <input
            type="radio"
            name="zoom"
            value=".9"
            checked={settings.zoom == .9}
            onChange={onChangeHandler}
          />
        </label>
        <label className="sidebar__radio">
          { MEDIUM }
          <input
            type="radio"
            name="zoom"
            value="1"
            checked={settings.zoom == 1}
            onChange={onChangeHandler}
          />
        </label>
        <label className="sidebar__radio">
          { BIG }
          <input
            type="radio"
            name="zoom"
            value="1.1"
            checked={settings.zoom == 1.1}
            onChange={onChangeHandler}
          />
        </label>
      </fieldset>
      { "geolocation" in navigator && (
      <label className={ "sidebar__checkbox " + (geolocationError ? " disabled" : "") }>
        { GEOLOCATION }
        <input type="checkbox" 
          name="geolocation" 
          onChange={onChangeHandler}
          checked={settings.geolocation === true} />
      </label>
      )}
      { "wakeLock" in navigator && (
      <label className="sidebar__checkbox">
        { KEEP_SCREEN_ACTIVE }
        <input type="checkbox" 
          name="wakelock" 
          onChange={onChangeHandler}
          checked={settings.wakelock === true} />
      </label>
      )}
    </form> 
  )

}

export default SettingsControl
